function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.5,
  d: "M34.368 29.428a.87.87 0 0 0 .873-.86v-1.98h.175c2.36 0 4.326-1.893 4.326-4.216 0-2.323-1.923-4.216-4.326-4.216H33.32c-1.398 0-2.578-1.119-2.578-2.496 0-1.376 1.136-2.495 2.578-2.495h4.15a.87.87 0 0 0 .875-.86.87.87 0 0 0-.874-.86h-2.272v-1.98a.87.87 0 0 0-.874-.86.87.87 0 0 0-.874.86v1.98h-.175c-2.359 0-4.325 1.892-4.325 4.215 0 2.324 1.922 4.217 4.325 4.217h2.098c1.398 0 2.577 1.118 2.577 2.495s-1.136 2.495-2.577 2.495h-4.151a.87.87 0 0 0-.874.86c0 .474.393.861.874.861h2.272v1.98c0 .473.393.86.874.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fil",
  fill: "#3D84FF",
  d: "M40.246 29.897l5.67-5.417a.56.56 0 0 1 .787 0l5.669 5.417a.503.503 0 0 1 0 .752l-.61.583a.56.56 0 0 1-.787 0l-3.646-3.483v10.604c0 .292-.257.537-.562.537h-.851c-.306 0-.563-.245-.563-.537V27.672l-3.726 3.56a.56.56 0 0 1-.787 0l-.61-.583a.516.516 0 0 1 .016-.752z"
}), /*#__PURE__*/React.createElement("path", {
  className: "primary-fill primary-stroke",
  fill: "#434957",
  stroke: "#434957",
  strokeWidth: 0.5,
  d: "M39.48 34.587c-1.73.613-3.533.92-5.373.92-9.164 0-16.635-7.623-16.635-16.969 0-9.345 7.434-17.006 16.635-17.006 9.164 0 16.599 7.622 16.599 16.968 0 1.379-.184 2.796-.479 4.137-.11.421.147.842.515.919a.708.708 0 0 0 .884-.536c.368-1.456.552-2.988.552-4.52C52.178 8.312 44.08 0 34.108 0 24.133 0 16 8.312 16 18.5 16 28.727 24.134 37 34.107 37c1.988 0 3.975-.345 5.852-.996.368-.153.589-.574.478-.957a.792.792 0 0 0-.956-.46z"
}));

const SvgIcPricing = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 38,
    viewBox: "0 0 70 38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcPricing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-pricing.3d1fbd8d.svg";
export { ForwardRef as ReactComponent };